import   React              ,
       { useEffect          ,
         useState          }  from "react";

import   classNames          from "classnames";

import   styles               from "./SentEmailList.module.scss";

import   TabularDisplay       from "../../widget/dataDisplay/tables/TabularDisplay";
import   AnimatedWaitingIcon2 from "../../widget/animations/animatedWaitingIcon2";
import   SentEmailPreviewFrame from "./SentEmailPreviewFrame";

import { groupData          }  from "../../../dataTypes/dataSetManagment/regroupData";

import { SentEmail          }  from "../../../dataTypes/sentEmailManagment/types";

import { getSentEmails      }  from "../../../backendServices/sentEmailManagment/api";

const formatDate = (date: Date | null): string => date ? date.toLocaleString() : "—";

interface SentEmailListProps {
  userEmail: string;
}

export const SentEmailList: React.FC<SentEmailListProps> = ({ userEmail }) => {

  const [ emails         , setEmails         ] = useState<SentEmail[]>([]);
  const [ showWaitingIcon, setShowWaitingIcon ] = useState(false);
  const [ ready          , setReady          ] = useState(false);

  useEffect(() => {

    const fetchData = async () => {
      setShowWaitingIcon(true);

      const result = await getSentEmails(userEmail);

      if (result.code === 1) {
        setEmails(result.payload);
      }

      setShowWaitingIcon(false);
      setReady(true);
    };

    fetchData();
  }, [userEmail]);

  const columns = [
    { header: "Date"  , accessor: "date"    as keyof SentEmail , width: '150px' , cellRenderer: (value: any) => <span>{formatDate(value)}</span> },
    { header: "Type"  , accessor: "type"    as keyof SentEmail , width: '220px' },
    { header: "Objet" , accessor: "subject" as keyof SentEmail },
  ];

  const groupedEmails = groupData<SentEmail>(emails, () => ({ key: '__all__' }));

  return (
    <div className={styles.root}>
      {showWaitingIcon && <AnimatedWaitingIcon2 />}

      {
       ready &&
       (
        emails.length === 0
        ?
        (
         <div className={styles.noDataMessage}>
          Aucun email envoyé pour ce compte.
         </div>
        )
        :
        (
         <div className={styles.tableSection}>
           <TabularDisplay
             groupedData        = {groupedEmails}
             columns            = {columns}
             showGroupHeaders   = {false}
             rowDetailRenderer  = {(row) => <SentEmailPreviewFrame bodyHtml={row.bodyHtml} />}
           />
         </div>
        )
       )
      }
    </div>
  );
};

export default SentEmailList;
